import client from './client';

export const fetchParticipants = async (surveyId = null) => {
  const params = {};
  if (surveyId) {
    params.survey = surveyId;
  }
  try {
    const response = await client.get('/api/participants/', { params });
    // Handle different response formats
    const responseData = response.data;
    let participants = [];
    
    if (Array.isArray(responseData)) {
      participants = responseData;
    } else if (responseData?.data && Array.isArray(responseData.data)) {
      participants = responseData.data;
    } else if (Array.isArray(responseData?.results)) {
      participants = responseData.results;
    } else if (Array.isArray(responseData?.data?.results)) {
      participants = responseData.data.results;
    } else {
      return [];
    }
    
    // Éliminer les doublons basés sur l'ID
    const uniqueParticipants = Array.from(new Map(participants.map(p => [p.id, p])).values());
    return uniqueParticipants;
  } catch (error) {
    throw error;
  }
};

export const fetchParticipantProfiles = async () => {
  try {
    const response = await client.get('/api/participants/profiles/');
    const responseData = response.data;
    let participants = [];
    
    if (Array.isArray(responseData)) {
      participants = responseData;
    } else if (Array.isArray(responseData?.results)) {
      participants = responseData.results;
    } else if (Array.isArray(responseData?.data)) {
      participants = responseData.data;
    } else if (Array.isArray(responseData?.data?.results)) {
      participants = responseData.data.results;
    } else {
      return [];
    }
    
    // Éliminer les doublons basés sur l'ID
    const uniqueParticipants = Array.from(
      new Map(
        participants.map((p) => {
          const emailKey = (p.email || '').trim().toLowerCase();
          const fallbackKey = String(p.source_participant_id ?? p.id ?? '');
          return [emailKey || fallbackKey, p];
        }),
      ).values(),
    );
    return uniqueParticipants;
  } catch (error) {
    throw error;
  }
};

export const createParticipant = async (participantData) => {
  try {
    const response = await client.post('/api/participants/', participantData);
    return response.data;
  } catch (error) {
    if (error.response) {
      // Le serveur a répondu avec un statut d'erreur
      
      // Si c'est une erreur de validation, afficher les détails
      if (error.response.status === 400 && error.response.data) {
        const errorMessages = [];
        for (const [field, errors] of Object.entries(error.response.data)) {
          if (Array.isArray(errors)) {
            errorMessages.push(`${field}: ${errors.join(', ')}`);
          } else if (typeof errors === 'string') {
            errorMessages.push(errors);
          } else if (typeof errors === 'object') {
            for (const [subField, subErrors] of Object.entries(errors)) {
              if (Array.isArray(subErrors)) {
                errorMessages.push(`${field}.${subField}: ${subErrors.join(', ')}`);
              } else {
                errorMessages.push(`${field}.${subField}: ${subErrors}`);
              }
            }
          }
        }
        
        if (errorMessages.length > 0) {
          error.validationErrors = errorMessages;
        }
      }
    }
    throw error;
  }
};

export const updateParticipant = async (id, participantData) => {
  try {
    console.log(`Mise à jour du participant ${id} avec les données:`, participantData);
    const response = await client.put(`/api/participants/${id}/`, participantData);
    console.log('Réponse du serveur:', response.data);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour du participant:', error);
    if (error.response) {
      // Le serveur a répondu avec un statut d'erreur
      console.error('Détails de l\'erreur:', {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers,
      });
      
      // Si c'est une erreur de validation, afficher les détails
      if (error.response.status === 400 && error.response.data) {
        const errorMessages = [];
        for (const [field, errors] of Object.entries(error.response.data)) {
          if (Array.isArray(errors)) {
            errorMessages.push(`${field}: ${errors.join(', ')}`);
          } else if (typeof errors === 'string') {
            errorMessages.push(errors);
          } else if (typeof errors === 'object') {
            for (const [subField, subErrors] of Object.entries(errors)) {
              if (Array.isArray(subErrors)) {
                errorMessages.push(`${field}.${subField}: ${subErrors.join(', ')}`);
              } else {
                errorMessages.push(`${field}.${subField}: ${subErrors}`);
              }
            }
          }
        }
        
        if (errorMessages.length > 0) {
          error.validationErrors = errorMessages;
          console.error('Erreurs de validation:', errorMessages);
        }
      }
    } else if (error.request) {
      // La requête a été faite mais aucune réponse n'a été reçue
      console.error('Aucune réponse du serveur:', error.request);
    } else {
      // Une erreur s'est produite lors de la configuration de la requête
      console.error('Erreur de configuration de la requête:', error.message);
    }
    throw error;
  }
};

export const deleteParticipant = async (id) => {
  try {
    const response = await client.delete(`/api/participants/${id}/`);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la suppression du participant:', error);
    throw error;
  }
};

export const sendInvitation = async (participantId) => {
  try {
    const response = await client.post(`/api/participants/${participantId}/send-invite/`);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de l\'envoi de l\'invitation:', error);
    throw error;
  }
};

